import React from "react"

const ServicosContext = React.createContext(null)

export default ServicosContext
